import * as React from 'react';
const SizeTabsContext = /*#__PURE__*/React.createContext('md');
if (process.env.NODE_ENV !== 'production') {
  SizeTabsContext.displayName = 'SizeTabsContext';
}
export default SizeTabsContext;